import React from 'react';
import { useWindowDimensions } from '@app/hooks';
import { View } from '@/styles/reactnative';
import HeaderBottomLists from './HeaderBottomLists';
import { useBalance } from '../../../../hooks/user/mybalance';
import BigNumber from 'bignumber.js';
import { getSetting, useSetting } from '../../../../hooks/user/mysetting';
import { SETTING_TYPE_SYSTEM } from '../../../../constants/SETTING';
import { useFetcherPublic } from '../../../../hooks/fetcher';
import { MobileCalVW, useIsMobile } from '@utils/CalVW.tsx';
import useSWR from 'swr';
import API from '@/utils/api';
import { useToken } from '@/app/hooks';

const AssetDerivativesHeaderBottom = () => {
  const { width } = useWindowDimensions();
  const isMobile = useIsMobile();
  const { token } = useToken();

  const { data: spot } = useBalance('USDT', 1);

  const balance = BigNumber(spot?.balance);

  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const settingCurrency = getSetting(setting, 'CURRENCY', 'USD');

  const currencyList = useFetcherPublic('/system/currency');
  const equiv = currencyList?.data?.result?.result?.find(
    (item: any) => item.code === settingCurrency
  );

  const equivValue = BigNumber(spot?.balance || 0)
    .multipliedBy(equiv?.price || 1)
    .toNumber();

  // PnL 데이터 가져오기
  const { data: pnlData } = useSWR('/v1/wallet/pnl-stats', async (url) => {
    const res = await API.get('/wallet/pnl-stats', token, {}, false);
    return res?.result;
  });

  const data = [
    {
      title: 'totalEquity',
      usd: balance.toFormat(4),
      currency: settingCurrency,
      currencyValue: equivValue,
      lock: spot?.lockbalance || 0,
    },
    {
      title: 'todayPnl',
      usd: new BigNumber(pnlData?.todayAmount || 0).toFormat(4),
      currency: settingCurrency,
      currencyValue: new BigNumber(pnlData?.todayAmount || 0)
        .multipliedBy(equiv?.price || 1)
        .toNumber(),
      isClickable: true, // 클릭 가능한 항목임을 표시
    },
  ];

  return (
    <View
      style={{
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: width < 1100 ? '100%' : '60%',
        height: 'auto',
        marginTop: isMobile ? MobileCalVW(30) : 0,
        gap: isMobile ? MobileCalVW(20) : 16,
      }}
    >
      {data.map((item, index) => (
        <HeaderBottomLists key={index.toString()} item={item} index={index} />
      ))}
    </View>
  );
};

export default React.memo(AssetDerivativesHeaderBottom);
